var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarEW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.87 94.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fc0;}.cls-2{fill:#f2e6d3;}.cls-3{fill:#e5d1ba;}.cls-4{fill:#dbbfa1;}.cls-5{fill:#e2574c;}.cls-6{fill:#e5766d;}.cls-7{fill:#cb4e44;}.cls-8{fill:#fff;}.cls-9{fill:#c2afa1;}.cls-10{fill:#3db39e;}.cls-11{fill:#37a18e;}.cls-12{fill:#61bfaf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.43,
    cy: 47.43,
    r: 47.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.88,64.27h2V68.8h-5.7l-1,.48h0l-.77.38h0l-1.24.6h0l-.78.38h0l-7.26,3.52,1.62,10.68,1.47,7.57a47.56,47.56,0,0,0,30.58-.11l3.07-18h0v0L60.54,71.6h0l-1.81-.9h0l-.34-.17-1.66-.82h0l-.84-.42h0l-1-.49H49.11V64.27h2.12l11-5.52,3.65-18.34-1-17.27-8.35-5.66H38.72l-8.58,6.29-1,16.65,3.68,18.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "65.89 40.41 61.73 23.97 56.09 25.09 58.54 36.71 47.52 42.23 47.52 53.11 58.43 57.29 43.88 64.27 51.23 64.27 62.24 58.75 65.89 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "65.89 40.41 64.91 23.14 61.73 23.97 65.89 40.41 58.43 57.29 62.24 58.75 65.89 40.41 65.89 40.41 65.89 40.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70,34.94l4.31-5.74-4.78-7.84L65.93,10,56.06,5.13l-8.51,3.7-8.8-3.7L29.22,10,25.56,21.37,20.79,29.2l4.33,5.73-4.33,4.64L24.94,51l-2.75,2.55,5.41,9.64,2.16-1.85,7.9,6.43,2.86-3.06,5.4,1.53v-2h-2l-11-5.63h0l-.75-3.75L29.18,40.32,36,31.76l3.89,3.17,6.21-7.85L63.52,23.6l2.39,16.81L63,54.89l-.76,3.77-11,5.61H49.12v2l5.48-1.53,2.88,3.06,7.9-6.42,2.15,1.84L73,53.53,70.2,51l4.14-11.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.55 8.83 47.55 17.37 63.52 23.6 56.06 5.13 47.55 8.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.11,54.89l-5.31,1.2-6-16.52,4.33-4.64,4.06,5.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "38.75 5.13 29.21 10 25.56 21.37 38.75 17.39 38.75 5.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.18 40.32 42 24.32 31.56 23.61 29.18 40.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "62.26 58.66 67.53 63.17 72.95 53.53 70.2 50.98 68.34 56.09 63.02 54.89 62.26 58.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "65.91 40.41 74.34 29.2 69.56 21.36 63.52 23.6 65.91 40.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "62.27 58.65 65.47 61.26 57.48 67.75 54.6 64.69 49.12 66.22 49.12 64.27 51.26 64.27 62.27 58.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "31.56 23.61 42 24.32 47.55 17.37 38.75 17.39 31.56 23.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "32.86 58.64 29.76 61.32 37.66 67.75 40.52 64.69 45.92 66.22 45.92 64.27 43.88 64.27 32.86 58.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.11 68.8 45.92 65.04 49.11 65.04 49.11 68.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.92,
    y: 64.27,
    width: 3.19,
    height: 0.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "57.88 70.28 47.61 79.08 37.22 70.24 36.45 70.62 47.61 80.22 58.73 70.7 57.88 70.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "55.89 69.29 47.61 76.49 39.22 69.27 38.45 69.65 47.61 77.63 56.73 69.71 55.89 69.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.68,93.5l-.06-1.77,3-3-.87-17L54.9,68.8H47.61V94.86A47.06,47.06,0,0,0,58.68,93.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.8,93.66v-2l-2.91-2.93L34.64,75l-3.83,9.83,1.47,7.57C33.75,92.88,35.26,93.3,36.8,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.45,93.56c1.41-.34,2.8-.73,4.16-1.19l3.32-18.16L60.54,71.6l.83,17.21-2.92,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M56.92,93.9l-9.31-7.69v8.65A47.57,47.57,0,0,0,56.92,93.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M36.83,93.66v-2l-2.92-2.93L34.63,75l-3.82,9.78,1.47,7.57A45.58,45.58,0,0,0,36.83,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M58.48,93.55c1.49-.35,3-.78,4.38-1.27l3.07-18L60.54,71.6l.85,17.21-2.91,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M58.68,93.5l-.06-1.79,3-2.94-.87-17L54.9,68.8l-7.29,6V89.21L56.35,94C57.13,93.86,57.91,93.69,58.68,93.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.66,75,33.6,88.76l2.83,2.9v1.91a47.45,47.45,0,0,0,11,1.29h.18V74.76l-7.39-6-11,5.34,1.62,10.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarEW);
export default __webpack_public_path__ + "static/media/avatar-e-w.4faaaf5f4781bd64402dae7e82cb22ee.svg";
export { ForwardRef as ReactComponent };